import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";
if (environment.production) {
  enableProdMode();
}


Sentry.init({
  dsn: environment.sentryDsn,
  environment: detectEnvironmentSimple(environment.baseUrl) || 'staging',
  ignoreErrors: [
    // Route errors
    /Cannot match any routes/,
    /Router outlet/,
    /NavigationError/,
    /Route not found/i,

    // HTTP errors
    /Http failure response.*: 400/,
    /Http failure response.*: 404/,
    /HttpErrorResponse/,

    // Existing filters
    /ChunkLoadError/,
  ],
  // enabling logs
  _experiments: { enableLogs: true },
  // sampling configuration
  tracesSampleRate: environment.production ? 0.2 : 1.0,
  profilesSampleRate: environment.production ? 0.2 : 1.0,
  replaysSessionSampleRate: environment.production ? 0.01 : 0.1,
  replaysOnErrorSampleRate: 0.3,
 
  integrations: [
    Sentry.eventFiltersIntegration(),
    Sentry.browserTracingIntegration({
      enableInp: true, // Interaction to Next Paint monitoring
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    // send console.log, console.error, and console.warn calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
  ],

  beforeSend(event, hint) {
    if (event.exception?.values?.[0]?.value?.includes('ChunkLoadError')) {
      return null; // Filter common deployment errors
    }
    if (event.exception) {
      const error = hint?.originalException as any;
      if (error?.componentContext) {
        if (event.tags) {
          event.tags['component'] = error.componentContext.componentName;
          event.tags['method'] = error.componentContext.methodName;
        }

        event.contexts = {
          ...event.contexts,
          component: error.componentContext,
        };
      }
    }
    return event;
  },
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

type EnvironmentType =
  | 'dev'
  | 'staging'
  | 'preproduction'
  | 'production';

function detectEnvironmentSimple(baseUrl: string): EnvironmentType {
  const environmentMap: Record<string, EnvironmentType> = {
    staging: 'staging',
    preprod: 'preproduction',
    dev: 'dev',
    localhost: 'dev',
  };

  for (const [keyword, env] of Object.entries(environmentMap)) {
    if (baseUrl.includes(keyword)) {
      return env;
    }
  }

  return 'production'; // Default fallback
}
